import * as actionTypes from "./ActionTypes";


export const clearStateAction = (stateName) => {
  return { type: actionTypes.CLEAR_STATE, stateName };
};

export const setIntervalAction = (interval) => {
  return { type: actionTypes.SET_INTERVAL, interval };
};

export const getAnalyticsDataAction = (data) => {
  return { type: actionTypes.GET_DATA, data };
};
export const getAnalyticsDataSuccessAction = (res) => {
  return { type: actionTypes.GET_DATA_SUCCESS, res };
};
export const getAnalyticsDataFailAction = (error) => {
  return { type: actionTypes.GET_DATA_FAIL, error };
};